import {
  type AgentThreadMessage,
  AgentThreadRole,
} from "@/shared/domain/agentThread/AgentThreadRecord";

/**
 * Whether the thread view labels user messages with who sent them: only when
 * someone other than the viewer sent one, as in a thread shared with the org
 * where a teammate asked a follow-up. A thread the viewer alone wrote stays
 * unlabeled. Messages with no recorded author (sent before authors were
 * recorded, or written by an agent launch, trigger or Slack mention) neither
 * count as someone else's nor get a label.
 */
export function shouldShowMessageAuthors(
  messages: AgentThreadMessage[],
  viewerUserId: string | undefined,
): boolean {
  return messages.some((message) =>
    isSentByAnotherMember(message, viewerUserId),
  );
}

/**
 * Whether a user message was sent by someone other than the viewer. The view
 * sets such a message on the left, apart from the viewer's own on the right.
 * A message with no recorded author is not.
 */
export function isSentByAnotherMember(
  message: AgentThreadMessage,
  viewerUserId: string | undefined,
): boolean {
  return (
    viewerUserId !== undefined &&
    message.role === AgentThreadRole.USER &&
    typeof message.created_by === "string" &&
    message.created_by !== viewerUserId
  );
}
